<template>
    <b-container class="position-relative px-0">
        <div v-show="is_template_edit_state && edit_mode"
            class="mb-4"
            >
            <b-card no-body class="p-2">
                <b-form-checkbox
                    v-model="is_activated_category2_check"
                    variant="warning"
                    class="mb-2"
                    switch
                    >
                    카테고리2 질문명 체크 활성화
                </b-form-checkbox>

                <p class="small text-muted mb-1">질문을 끌어서 옮기면 순서가 바로 저장됩니다.</p>
                <b-btn-group class="w-100">
                    <b-btn
                        variant="blue"
                        size="sm"
                        @click="addNewQuestion"
                        :disabled="action_state.addNewQst"
                        >
                        <span v-show="!action_state.addNewQst">
                            새질문 <fa icon="plus-square" />
                        </span>
                        <span v-show="action_state.addNewQst">
                            <b-spinner style="height: 1rem;width: 1rem;"></b-spinner>
                        </span>
                    </b-btn>
                    <b-btn
                        variant="warning"
                        size="sm"
                        @click="validateCategory2Name"
                        :disabled="action_state.validateCategory2 || !is_activated_category2_check || !template_contents.length"
                        >
                        <span v-show="!action_state.validateCategory2">
                            카테고리2 질문명
                            <fa icon="check-square" />
                        </span>
                        <span v-show="action_state.validateCategory2">
                            <b-spinner style="height: 1rem;width: 1rem;"></b-spinner>
                        </span>
                    </b-btn>
                    <b-btn
                        variant="info"
                        size="sm"
                        :to="{name: 'EditingTemplateTranslation', params: { template_code }}"
                        :disabled="($route.params.value_new === true && (!$route.params.template_id || $route.params.template_id === '')) || !template_contents.length"
                        >
                        번역
                        <BIconPencilSquare font-scale="0.98" shift-v="2.5" />
                    </b-btn>
                    <b-btn
                        variant="dark"
                        size="sm"
                        @click="saveTemplate(template_contents)"
                        :disabled="!!notValidCategory2Name.length || action_state.save || !template_contents.length"
                        >
                        <span v-show="!action_state.save">
                            저장
                            <fa icon="save" />
                        </span>
                        <span v-show="action_state.save">
                            <b-spinner style="height: 1rem;width: 1rem;"></b-spinner>
                        </span>
                    </b-btn>
                </b-btn-group>
            </b-card>
        </div>
        <template v-if="template_contents.length > 0">
            <Tree
                :data="template_contents"
                :draggable="is_template_edit_state && !is_editing"
                :droppable="is_template_edit_state && !is_editing"
                :preventSelect="!is_template_edit_state && !is_editing"
                :isDragPlaceHolder="true"
                :space="15"
                :indent="17.5"
                @change="updateQuestionTree"
                class="border border-light mb-4"
                >
                <template v-slot="{ data, store }">
                    <div v-if="!data.isDragPlaceholder" 
                        :class="audit_mode === true ? 'in-audit' : ''"
                        @click.stop="!is_template_edit_state && !is_editing
                            ?   $router.push({
                                    name: $route.name,
                                    query: { ...$route.query, question_id: data.question_code }
                                })
                            : null"
                        >
                        <b-list-group-item 
                            :class="[active_id == data.question_code ? `node-level-${data._vm.level}-active`: '', `node-level-${data._vm.level}`]"
                            @click="is_template_edit_state || is_editing? null : activateList(data.question_code)"
                            >
                            <div class="d-flex align-items-center justify-content-between"> 
                                <div>
                                    <template v-if="is_template_edit_state">
                                        <fa :id="`handle-${data._id}`" icon="grip-vertical" class="mr-2 handle">
                                    </fa>
                                    </template>
                                    <template v-if="is_activated_category2_check && data._vm.level === 2 && notValidCategory2Name.includes(data._id)">
                                        <b-tooltip ref="tooltip"
                                            :target="`category2-valid-alert-${data._id}`"
                                            >
                                            Category2 레벨의 제목으로 적절치 않습니다. (검색 후) 수정해주세요.
                                        </b-tooltip>
                                    </template>
                                    <fa v-show="is_activated_category2_check && data._vm.level === 2 && notValidCategory2Name.includes(data._id)"
                                        :id="`category2-valid-alert-${data._id}`"
                                        icon="exclamation-triangle"
                                        class="ml-3 mr-2 text-danger"
                                        >
                                    </fa>
                                    <template v-if="modify_id === data._id && edit_mode">
                                        <b-input class="d-inline f-90 w-auto" v-model.trim="data.question_name"
                                            @keyup.enter="UpdateName(data, store)" @keyup.esc="cancelModifyNode" />
                                    </template>
                                    <template v-else>
                                        <span> {{ showTranslation(data.question_name, data.question_name_e, data.question_name_c) }} </span>
                                    </template>
                                </div>

                                <div class="d-flex align-items-center">
                                    <div v-if="data.children && data.children.length"
                                        class="float-right" 
                                        @click.stop="store.toggleOpen(data)"
                                        >
                                        <fa :icon="data.open ? 'angle-up' : 'angle-down'" class="mr-2"></fa>
                                    </div>

                                    <template v-if="edit_mode && is_template_edit_state">
                                        <!-- <template v-if="selected_copying_questions">
                                            <b-form-checkbox
                                                :id="`question-${data._id}-copying-checkbox`"
                                                v-model="selected_copying_questions"
                                                name="question-copying-checkbox"
                                                :value="data.question_code"
                                                unchecked-value=""
                                                class="mb-0"
                                                />
                                        </template> -->
                                        <template v-if="modify_id === data._id">
                                            <b-button size="sm" variant="icon" @click.stop="cancelModifyNode">
                                                <BIconArrowClockwise />
                                            </b-button>
                                            <b-button size="sm" variant="icon" @click.stop="UpdateName(data, store)">
                                                <fa icon="save"></fa>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <b-button size="sm" variant="icon" @click.stop="modifyNode(data._id, store, data.question_name)">
                                                <fa icon="pen"></fa>
                                            </b-button>
                                        </template>
                                        <b-button size="sm" variant="icon" @click.stop="handleDeleteQuestion(data._id)">
                                            <fa icon="trash-alt"></fa>
                                        </b-button>
                                        <b-modal :ref="`delete-modal-${data._id}`" title="경고" header-bg-variant="danger"
                                            @ok="deleteQuestion(data._id, store, data.question_code)"
                                            ok-variant="danger"
                                            >
                                            <p> 삭제를 진행할 경우 선택한 <span class="font-weight-bold font-italic">"{{ data.question_name }}" 질문 문항</span> 관련된 내용이 삭제되며 되돌릴 수 없습니다.</p>
                                            <p v-if="countDescendants(data)" class="text-danger font-weight-bold"> 하위 질문 {{ countDescendants(data) }}개도 함께 삭제됩니다. </p>
                                            <p> 계속 하시겠습니까? </p>
                                        </b-modal>
                                    </template>
                                </div>
                            </div>
                        </b-list-group-item>
                    </div>
                </template>
            </Tree>
        </template>
        <template v-else>
            <div class="text-center bgray-200 rounded py-5 mb-4">
                {{is_empty_template_meta ? "질문지 템플릿 명 및 유형을 입력 및 저장해주세요." : "'새질문'으로 질문 리스트를 만드세요."}}
            </div>
        </template>

        <div class="pt-2 mb-4">
            <hr class="mt-0 pb-0">
        </div>

        <div v-show="is_activated_category2_check && !!notValidCategory2Name.length">
            <div class="bg-danger text-center text-white f-95 shadow rounded p-2 mb-3">
                잘못된 Category2 질문제목으로 인해 변경사항을 저장할 수 없습니다. 추후 수정 예정이시라면 <i class="font-weight-bold">"새질문"</i> 이라고 입력해주세요.
            </div>

            <div class="pt-2 mb-4">
                <hr class="mt-0 pb-0">
            </div>
        </div>

        <category2-search-group
            :category2_list="category2_list"
            :disabled="!is_template_edit_state || is_editing || is_activated_category2_check || is_activated_action_state"
            @add-category2-question="addNewQuestion"
            />

        <div class="pt-2 mb-4">
            <hr class="mt-0 pb-0">
        </div>

        <div class="d-flex flex-column text-right">
            <p v-show="edit_mode" class="small text-muted mb-1">질문을 끌어서 옮기면 순서가 바로 저장됩니다.</p>
            <b-button v-show="edit_mode"
                variant="blue"
                size="sm"
                class="mb-2"
                title="새질문 추가하기"
                :disabled="action_state.addNewQst || is_empty_template_meta"
                @click.prevent="addNewQuestion"
                >
                <span v-show="!action_state.addNewQst">
                    <fa icon="plus" class="mr-2"></fa>
                    새질문 추가하기
                </span>
                <span v-show="action_state.addNewQst">
                    <b-spinner style="height: 1rem;width: 1rem;"></b-spinner>
                </span>

                
            </b-button>
            <b-button v-show="edit_mode"
                variant="warning"
                size="sm"
                class="mb-2"
                @click="validateCategory2Name"
                :disabled="action_state.validateCategory2 || !is_activated_category2_check || is_empty_template_meta"
                >
                <span v-show="!action_state.validateCategory2">
                    <fa icon="check" class="mr-2"></fa>
                    카테고리2 질문명 체크
                </span>
                <span v-show="action_state.validateCategory2">
                    <b-spinner style="height: 1rem;width: 1rem;"></b-spinner>
                </span>

                
            </b-button>
            <b-button v-show="edit_mode"
                variant="dark"
                size="sm"
                @click.prevent="saveTemplate(template_contents)"
                :disabled="!!notValidCategory2Name.length || action_state.save || is_empty_template_meta"
                >
                <span v-show="!action_state.save">
                    <fa icon="save" class="mr-2"></fa>
                    저장
                </span>
                <span v-show="action_state.save">
                    <b-spinner style="height: 1rem;width: 1rem;"></b-spinner>
                </span>
            </b-button>
        </div>
    </b-container>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import { mapActions, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { DraggableTree } from 'vue-draggable-nested-tree'
import category2SearchGroup from '@core_components/admin/components/templates/category2-search-group';

export default {
    name: 'TemplateTree',
    components: {
        Tree : DraggableTree,
        category2SearchGroup
    },
    props: {
        audit_mode: {
            type: Boolean,
        },
        is_template_contents_edit_mode: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            is_activated_category2_check: false,
            modify_id: null,
            active_id: null,
            is_editing: false,
            is_collapseall: false,
            delete_target_id: '',
            edit_target_question_parent_tree: [],
            notValidCategory2Name: [],
            passCategory2NamesValidation: [
                '조직 기본정보',
                '규제자유특구 특구사업자 추가 질문'
            ],
            category2_list: [],
            action_state: {
                save: null,
                validateCategory2: null,
                addNewQst: null
            },

            // new
            template_contents: [],
            template_type: null
        }
    },
    computed: {
        ...mapState([ 'template_tree', 'is_template_edit_state', 'question_composition' ]),
        ...mapState('questions', ['answer_company']),
        template_code () {
            return this.$route.query.value_new === true
                ? null
                : this.$route.query.template_id
        },
        // collapsed_template_tree () {
        //     return this.$store.getters.getShowTemplateSubFinder
        // },
        // template_tree () {
        //     return { ...this.$store.getters.getTemplateTree }
        // },
        // answer_company () {
        //     return this.$store.getters['questions/getter_question_answer_company']
        // },
        edit_mode () {
            return this.$store.getters['questions/getter_question_edit_mode']
        },
        category2ValidationDataSet () {
            const category2_name_set = this.category2_list.map(_category2_ele => _category2_ele.category2_name)
            return [...category2_name_set, ...this.passCategory2NamesValidation, '새질문']
        },
        is_activated_action_state () {
            return Object.values(this.action_state).some(state => state === true)
        },
        is_empty_template_meta () {
            return this.isFieldEmpty(this.template_tree.template_name) || this.isFieldEmpty(this.template_tree.template_type)
        }
    },
    watch: {
        'template_tree': {
            deep: true,
            handler (_updated_template) {
                const { template_type, template_contents } = _updated_template
                this.template_type = template_type
                this.template_contents = cloneDeep(template_contents)
            }
        },
        '$route.query.question_id' (_question_code) {
            if (!this.is_template_edit_state && (_question_code && (!this.active_id || _question_code !== this.active_id))) {
                this.activateList(_question_code)
            }
        },
        is_template_edit_state: {
            handler (_template_edit_state) {
                if (_template_edit_state) {
                    this.activateList(null)
                } else {
                    this.activateList(this.$route.query.question_id || null)
                }
            }
        },
        is_template_contents_edit_mode(value){
            if(!value) this.cancelModifyNode()
        },
        async is_activated_category2_check (aft, bef) {
            if (aft && !bef) {
                await this.validateCategory2Name()
            }
        },
        // is_selecting_copying_questions (_selecting_copying_questions_state) {
        //     if (!_selecting_copying_questions_state) {
        //         this.selected_copying_questions = []
        //     }
        // },
        // selected_copying_questions (_selected_copying_questions) {
        //     this.$emit("send-selected-questions", _selected_copying_questions)
        // }
    },
    created () {
        this.template_contents = cloneDeep(this.template_tree.template_contents)
        if (this.$route.query.question_id && (!this.active_id || this.active_id !== this.$route.query.question_id)) {
            this.activateList(this.$route.query.question_id)
        }
    },
    async mounted () {
        try {
            const res_category2_list =  await this.$axios.get('/admin/questions/category2s')
            const _codes_passCategory2NamesValidation = this.passCategory2NamesValidation.map((_pass_cat2_name, _p) => {
                return { category2_code: null, category2_name: _pass_cat2_name, index: _p + res_category2_list.data.length }
            })
            this.category2_list = [ ...res_category2_list.data, ..._codes_passCategory2NamesValidation ]
        } catch (error) {
            if (this.isUnauthorized(error)) return
            this.$EventBus.$emit('toast-failure', 'category2 목록 로딩 실패', getErrorMessage(error, 'category2 목록을 불러오지 못했습니다.'))
        }
    },
    methods: {
        ...mapActions([ 'saveQuestionComposition', 'saveTemplateTree', 'deleteQuestionComposition' ]),
        async addNewQuestion (new_question_name = '새질문') {
            try {
                if (typeof new_question_name === 'object') {
                    new_question_name = '새질문'
                }

                this.action_state.addNewQst = true
                // ponytail: 무작위 코드(1e9 공간) — 충돌 시 서버가 덮어쓰는지 확인되면 서버 발급으로 바꾼다
                const _new_question = {
                    question_code: 'q' + Math.floor(Math.random() * 1000000000),
                    question_name: new_question_name,
                    question_infobox: '',
                    question_contents: []
                }
                // 질문 생성이 question_composition 을 새 질문으로 바꾸므로, 목록에 못 붙으면 되돌릴 값을 잡아 둔다
                const _prev_composition = cloneDeep(this.question_composition)

                await this.saveQuestionComposition(_new_question)
                const is_saved = await this.saveTemplate([ ...this.template_tree.template_contents, _new_question ], '새 질문 추가 실패')
                if (!is_saved) {
                    // 응답만 잃고 서버에는 저장됐을 수 있다 — 서버 목록을 다시 읽어 연결되지 않은 게 확인될 때만 지운다
                    // (못 읽으면 지우지 않는다: 목록이 가리키는 질문을 지우는 것보다 보이지 않는 빈 질문이 남는 쪽이 안전하다)
                    const is_linked = await this.$store.dispatch('readTemplateTree', { template_code: this.template_tree.template_code })
                        .then(() => JSON.stringify(this.template_tree.template_contents || []).includes(`"${_new_question.question_code}"`))
                        .catch(() => true)
                    if (is_linked) return this.$store.commit('reset_question_subs')
                    // 목록에 붙지 못한 질문 레코드는 지운다(남으면 화면에 안 보이는 빈 질문이 서버에 쌓인다)
                    await this.deleteQuestionComposition(_new_question.question_code)
                        .catch(error => console.warn('[TemplateTree] 목록에 못 붙은 새 질문 정리 실패', _new_question.question_code, error))
                    this.$store.commit('update_question_composition', _prev_composition)
                    return
                }
                this.$store.commit('reset_question_subs')
            } catch (error) {
                if (this.isUnauthorized(error)) return
                this.$EventBus.$emit('toast-failure', '새 질문 추가 실패', getErrorMessage(error, '새 질문을 만들지 못했습니다. 잠시 후 다시 시도해 주세요.'))
            } finally {
                this.action_state.addNewQst = false
            }
        },
        async deleteQuestion (delete_target_id, tree, quesiton_code) {
            try {
                // 화면 트리를 먼저 지우지 않고, 대상을 뺀 내용을 저장한 뒤 저장된 결과로 화면을 갱신한다(실패하면 화면 그대로).
                const target_node = tree.getNodeById(delete_target_id)
                const deleted_codes = []
                const collectCodes = (node) => {
                    deleted_codes.push(node.question_code)
                    // 삭제 대상과 하위 노드가 invalid 목록에 남아 저장을 막지 않게 먼저 뺀다
                    if (this.is_activated_category2_check) this.removeNotValidCategory2Id(node._id)
                    ;(node.children || []).forEach(collectCodes)
                }
                collectCodes(target_node)
                const removeNode = (nodes) => nodes
                    .filter(node => node.question_code !== quesiton_code)
                    .map(node => ({ ...node, children: removeNode(node.children || []) }))

                const is_saved = await this.saveTemplate(removeNode(this.template_contents))
                if (!is_saved) return

                if (this.is_activated_category2_check) {
                    this.removeNotValidCategory2Id(delete_target_id)
                }

                // 하위 질문 레코드도 함께 지운다(트리에서만 빠지면 고아 레코드가 남는다)
                let failed_count = 0
                for (const code of deleted_codes) {
                    try {
                        await this.deleteQuestionComposition(code)
                    } catch (error) {
                        failed_count++
                    }
                }
                if (failed_count) {
                    alert(`질문은 목록에서 삭제되었지만 질문 레코드 ${failed_count}건은 삭제하지 못했습니다. 개발팀에 문의해주세요.`)
                }
                this.$store.commit('update_Show_Template_SubFinder', false)
            } catch (error) {
                alert("질문을 삭제하는 도중 장애가 발생했습니다. 개발팀에 문의해주세요.")
            }
        },
        async updateQuestionTree (node) {
            /**
             * 본 함수가 받을 수 있는 arg: node, targetTree, oldTree
             */
            if (this.is_activated_category2_check) {
                this.$nextTick(async () => {
                    if (node._vm.level === 2) {
                        if (!this.passCategory2NamesValidation.includes(node.question_name)) {
                            await this.$axios.get('/admin/questions/validate', {
                                params: { question_name: node.question_name, template_code: this.template_code }
                            }).catch(error => {
                                if (error.response) {
                                    if (error.response.status === 404) {
                                        if (this.is_activated_category2_check) {
                                            this.addNotValidCategory2Id(node._id)
                                        }
                                    }   
                                }
                            })
                        }
                        
                    } else if (node._vm.level === 1 && node.children.length) {
                        if (this.is_activated_category2_check) {
                            this.removeNotValidCategory2Id(node._id)
                        }
                        
                        node.children.forEach(async (_node_child) => {
                            if (!this.passCategory2NamesValidation.includes(_node_child.question_name)) {
                                await this.$axios.get(path, {
                                    params: { question_name: _node_child.question_name, template_code: this.template_code }
                                }).catch(error => {
                                    if (error.response) {
                                        if (error.response.status === 404) {
                                            if (this.is_activated_category2_check) {
                                                this.addNotValidCategory2Id(_node_child._id)
                                            }
                                        }   
                                    }
                                })
                            }
                        });
                    } else {
                        if (this.is_activated_category2_check) {
                            this.removeNotValidCategory2Id(node._id)
                        }
                    }
                }) 
            }

            const is_saved = await this.saveTemplate(this.template_contents, '순서를 저장하지 못해 이전 순서로 되돌렸습니다')
            if (is_saved) {
                this.$EventBus.$emit('toast-success', '질문 순서 저장', '질문 순서를 저장했습니다.')
            } else {
                // 화면 순서와 서버 순서가 달라지지 않게 마지막으로 저장된 트리(store)로 되돌린다
                this.template_contents = cloneDeep(this.template_tree.template_contents)
            }
        },
        async UpdateName (data) {
            /**
             * 본 함수가 받을 수 있는 arg: data(node), store(targetTree)
             */
            if (!data.question_name) {
                return this.$EventBus.$emit('toast-warning', '질문 이름 확인', '질문 이름을 입력해 주세요.')
            }
            try {
                this.modifyNode()
                if (this.is_activated_category2_check && data._vm.level === 2 && !this.passCategory2NamesValidation.includes(data.question_name)) {
                    await this.$axios.get('/admin/questions/category2/validate', {
                        params: { question_name: data.question_name, template_code: this.template_code }
                    })
                }
                
                const {data: question_data} = await this.$axios.get('/questions', {
                    params: { question_code: data.question_code }
                })

                // store 의 saveQuestionComposition 은 지금 열린 질문이 아니면 번역(_e/_c)을 빼고 보내 서버가 배경정보 번역을
                // NULL 로 덮고, 열린 질문(question_composition)을 이 질문으로 바꿔 버린다. 이름만 바꾸는 저장이므로
                // 조회한 값을 그대로 실어 직접 보낸다(이름이 바뀌면 이름 번역은 서버가 새로 만든다).
                const { data: saved_question } = await this.$axios.post('/admin/questions', {
                    question_code: data.question_code,
                    question_name: data.question_name,
                    question_name_e: question_data.question_name_e,
                    question_name_c: question_data.question_name_c,
                    question_infobox: question_data.question_infobox,
                    question_infobox_e: question_data.question_infobox_e,
                    question_infobox_c: question_data.question_infobox_c,
                    question_contents: typeof question_data.question_contents === 'object'
                        ? JSON.stringify(question_data.question_contents)
                        : question_data.question_contents,
                    template_code: this.template_tree.template_code
                })
                if (this.question_composition && this.question_composition.question_code === data.question_code) {
                    this.$store.commit('update_question_composition', saved_question)
                }
                // 실패 사유는 saveTemplate 이 토스트로 알린다. 목록은 마지막으로 저장된 이름으로 되돌린다
                // (saveTemplate 이 편집 모드를 껐다 켜는 동안 부모 watcher 가 cancelModifyNode 를 부르기도 한다)
                if (!(await this.saveTemplate(this.template_contents, '질문 이름 저장 실패'))) {
                    this.cancelModifyNode()
                    return
                }

                if (data._vm.level === 2 && this.is_activated_category2_check) {
                    this.removeNotValidCategory2Id(data._id)
                }
                
                this.is_editing = false
            } catch (error) {
                if (this.isUnauthorized(error)) return
                let error_message = null
                if (error.response) {
                    if (error.response.status === 400) {
                        if (getErrorMessage(error, '') === 'tempale_code가 올바르지 않습니다.') {
                            error_message = '질문지 코드가 틀렸습니다. 확인 후 다시 진행해주세요.'
                        } else if (getErrorMessage(error, '') === 'template_type이 qesg_assessment가 아닙니다.') {
                            error_message = '질문지 타입이 qesg_assessment가 아닙니다.'
                        }
                    } else if (error.response.status === 404) {
                        if (getErrorMessage(error, '') === 'question_name이 일치하지 않습니다.') {
                            if (data._vm.level === 2 && this.is_activated_category2_check) {
                                this.addNotValidCategory2Id(data._id)
                            }
                            error_message = '올바르지 않은 질문 제목입니다.'
                        }
                    }
                }
                // 목록 저장 전 단계의 실패 — 입력 칸을 다시 열어 고치거나 취소(Esc)할 수 있게 한다
                this.modify_id = data._id
                this.$EventBus.$emit('toast-failure', '질문 이름 저장 실패', error_message || getErrorMessage(error, '질문 이름을 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.'))
            } finally {
                this.action_state.save = null
            }
        },
        /** 성공하면 true, 실패(검증·저장 오류)하면 사유를 토스트로 알리고 false */
        async saveTemplate (updated_temlate_content = this.template_contents, fail_title = '질문 목록 저장 실패') {
            try {
                this.$store.commit('update_Template_EditMode', false)
                this.action_state.save = true
                if (this.is_activated_category2_check) {
                    await this.validateCategory2Name(updated_temlate_content)
                }
                
                if (this.is_activated_category2_check && this.notValidCategory2Name.length) {
                    this.$EventBus.$emit('toast-warning', fail_title, '유효하지 않은 Category2 질문명이 있습니다. 수정 후 저장해주세요.')
                    return false
                }
                
                const _pure_template_contents = this.filterNestedQuestions(updated_temlate_content)
                await this.$store.dispatch('saveTemplateTree', { template_contents: _pure_template_contents })
                return true
            } catch (error) {
                if (!this.isUnauthorized(error)) {
                    this.$EventBus.$emit('toast-failure', fail_title, getErrorMessage(error, '질문 목록을 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.'))
                }
                return false
            } finally {
                this.action_state.save = false
                this.$store.commit('update_Template_EditMode', true)
            }
        },
        validateCategory2Name (updated_contents) {
            return new Promise((resolve) => {
                this.action_state.validateCategory2 = true
                
                const traverseCategory2Name = (templateContents) => {
                    if (templateContents.length) {
                        for (const templateContent of templateContents) {
                            if (templateContent._vm.level === 2) {
                                const isValidCategory2Name = this.category2ValidationDataSet.includes(templateContent.question_name)                            
                                if (!isValidCategory2Name) {
                                    this.addNotValidCategory2Id(templateContent._id)
                                } else {
                                    this.removeNotValidCategory2Id(templateContent._id)
                                }
                            }
                            
                            if (templateContent._vm.level === 1 && templateContent.children && templateContent.children.length) {
                                traverseCategory2Name(templateContent.children)
                            }
                        }
                    }
                }

                traverseCategory2Name(Array.isArray(updated_contents) ? updated_contents : this.template_contents)

                setTimeout(() => {
                    this.action_state.validateCategory2 = false
                    resolve(true)
                }, 800);
            });
        },
        addNotValidCategory2Id (_added_id) {
            if (!this.notValidCategory2Name.length) {
                this.notValidCategory2Name.push(_added_id)
            } else {
                const isExisted = this.notValidCategory2Name.indexOf(_added_id)
                if (isExisted < 0) {
                    this.notValidCategory2Name.push(_added_id)
                }
            }
        },
        removeNotValidCategory2Id (_remove_id) {
            if (this.notValidCategory2Name.length) {
                const _remove_target_idx = this.notValidCategory2Name.indexOf(_remove_id)
                if (_remove_target_idx > -1) {
                    this.notValidCategory2Name.splice(_remove_target_idx, 1);
                }
            }
        },
        // 401 은 인터셉터가 로그인으로 보낸다 — 화면은 알림 없이 멈춘다
        isUnauthorized (error) {
            return !!(error && error.response && error.response.status === 401)
        },
        modifyNode (x, t) {
            this.is_editing = true
            this.modify_id = x
        },
        cancelModifyNode () {
            this.is_editing = false
            this.modify_id = null
            this.template_contents = cloneDeep(this.template_tree.template_contents)
        },
        activateList (question_code = this.$route.query.question_id) {
            if (!this.is_template_edit_state) {
                this.active_id = question_code
            } else {
                this.active_id = null
            }
        },
        handleDeleteQuestion (x) {
            this.delete_target_id = x
            this.$refs[`delete-modal-${x}`].show()
        },
        countDescendants (node) {
            return (node.children || []).reduce((sum, child) => sum + 1 + this.countDescendants(child), 0)
        },
        filterNestedQuestions (data) {
            if (!Array.isArray(data)) return [];

            return data.map(({ question_name, question_name_c = null, question_name_e = null, question_infobox = null, question_infobox_c = null, question_infobox_e = null, question_code, children }) => ({
                question_name, question_name_c, question_name_e,
                question_infobox, question_infobox_c, question_infobox_e,
                question_code, children: children && Array.isArray(children) ? this.filterNestedQuestions(children) : []
            }));
        }
        // toggleDeleteMode (x) {
        //     // this.is_template_edit_state = x
        //     this.$store.commit('update_Template_EditMode', !this.is_template_edit_state)
        // },
        // expandAll () {
        //   th.breadthFirstSearch(this.template_contents, node => {
        //     node.open = true
        //   })
        //    return this.is_collapseall = false
        // },
        // collapseAll () {
        //   th.breadthFirstSearch(this.template_contents, node => {
        //     node.open = false
        //   })
        //     return this.is_collapseall = true
        // },
        // updateTree (question_code, question_name) {
        //     const new_template_contents = this.template_contents
        //     th.breadthFirstSearch(new_template_contents, node => {
        //         if (node.question_code == question_code) node.question_name = question_name
        //     })
        //     this.template_contents = new_template_contents
        // },
        // updateTemplateContent (_template, _template_id, _updatedField, _updatedValue) {
        //     for (const _subTemplate of _template) {
        //         if (_subTemplate._id === _template_id) {
        //             _subTemplate[_updatedField] = _updatedValue
        //             return _template
        //         }

        //         if (_subTemplate.children && _subTemplate.children.length) {
        //             return this.updateTemplateContent(_subTemplate.children, _template_id, _updatedField, _updatedValue)
        //         }
        //     }
        // }
    }
}
</script>

<style scoped>
.in-audit .node-level-1,
.in-audit .node-level-2,
.in-audit .node-level-3 {
    color: var(--gray-600);
    background-color: rgba(0,0,0,0);
}
.in-audit .node-level-1:hover,
.in-audit .node-level-2:hover,
.in-audit .node-level-3:hover {
    color:black;
    background-color: rgba(0,0,0,0);
}
.in-audit .node-level-1-active,
.in-audit .node-level-2-active,
.in-audit .node-level-3-active{
    color: white;
    background-color: var(--blue);
}
.in-audit .node-level-1 {
    padding: 0.3rem 0;
    border-bottom: 1px solid var(--gray-500);
}
.in-audit .node-level-2 {
    padding: 0.2rem;
}


.node-level-1,
.node-level-2,
.node-level-3{
    font-weight: 500;
    width: 100%;
    padding: 0.25rem 0.5rem;
    border: 0;
    border-radius: 0;
}
.node-level-1{
    background-color: var(--gray-300);   
}
.node-level-2{
    color: var(--gray-600);
    background-color: var(--gray-200);
}
.node-level-3{
    font-size: 0.9rem;
    color: var(--gray-600);
    background-color: var(--gray-100);
}

.node-level-1:hover,
.node-level-2:hover,
.node-level-3:hover,
.node-level-4:hover{
    color: var(--gray-550);
    cursor: pointer;
}
.node-level-1-active,
.node-level-2-active,
.node-level-3-active,
.node-level-4-active {
    background-color: var(--blue);
    color: var(--gray-100);
}

.node {
    cursor: pointer;
}


/*안쓰는 스타일
.ih-button{
    font-size: 0.9rem;
    padding: 0.2rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    margin-left: 5px;
    margin-bottom: 20px;
}

.ih-modify{
    font-size: 0.8rem;
    padding: 0.2rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    margin-left: 5px;
}

.ih-delete{
    font-size: 0.8rem;
    padding: 0.2rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    margin-left: 5px;
}*/

.tree-node-inner-back {
  padding: 5px;
  cursor: pointer;
}

.draggable-placeholder-inner{
  border: 1px dashed #0088F8;
  box-sizing: border-box;
  background: rgba(0, 136, 249, 0.09);
  color: #0088f9;
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
}

.draggable-placeholder-inner{
    background-color: orangered;
}

</style>
